import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  background: linear-gradient(268deg, #ffd503 0%, #ffdf22 100%);
  border-radius: 5rem;
  outline: none !important;

  height: 5rem;
  padding: 2rem;
  width: 100%;
  /* max-width: 32rem; */

  transition: 180ms ease-in;
  opacity: 1;

  &:hover {
    opacity: 0.85;
  }
`;

export const ButtonText = styled.p`
  font-weight: bold;
  font-size: 2rem;
  letter-spacing: 0.1rem;
  color: #000000;
  text-transform: uppercase;

  margin-left: 1rem;
`;
